/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Vendor Requires
require('./vendor/bootstrap.min');
require('./vendor/imagesloaded.pkgd.min.js');
require('./vendor/jquery.actual.min');

// Optional Vendor Requires
// require('./vendor/jquery.validate.min');
require('./vendor/object-visual-lock');
require('./vendor/js.cookie');
require('./vendor/slick.min');
// require('./vendor/accessible-slick-1.0.1/slick/slick.min');
// require('./vendor/youtube-iframe-assistant');
require('./vendor/picturefill');

// App Requires
require('./app/config');
require('./app/helpers');
require('./app/global');
require('./app/header');
require('./app/walk-paths');
require('./app/carousels');
require('./app/business-hours-ball');
require('./app/exhibits');
require('./app/color-block-grid');
require('./app/hours-tabs');
require('./app/frequently-asked-questions');
require('./app/blog');
require('./app/videos');
require('./app/events');
require('./app/forms');
require('./app/dropcaps');
require('./app/home-hero');
require('./app/graphic-dots');
// require('./app/tabs');

// $('#site-footer').objectVisualLock(250, true);

$('body').imagesLoaded(function () {
    // $('img[src$=".svg"]').each(function() {
    //     var $img = jQuery(this);
    //     var imgURL = $img.attr('src');
    //     var attributes = $img.prop("attributes");
    //
    //     $.get(imgURL, function(data) {
    //         // Get the SVG tag, ignore the rest
    //         var $svg = jQuery(data).find('svg');
    //
    //         // Remove any invalid XML tags
    //         $svg = $svg.removeAttr('xmlns:a');
    //
    //         // Loop through IMG attributes and apply on SVG
    //         $.each(attributes, function() {
    //             $svg.attr(this.name, this.value);
    //         });
    //
    //         // Replace IMG with SVG
    //         $img.replaceWith($svg);
    //     }, 'xml');
    // });
});


jQuery(document).ready(function ($) {
    $('.slick-dots').removeAttr('role');
    $('.slick-track').removeAttr('role');
    $('.carousel-item').removeAttr('role');
});
jQuery(document).ready(function($) {
    $('.slick-dots li').removeAttr('aria-hidden');
    $('.tribe-events-calendar-month__mobile-events-icon[title="Has events"]').removeAttr('aria-label');
    $('em[title="Has events"]').removeAttr('aria-label');
});

